import * as yup from 'yup';
import { onboardingConstants } from '@/lib/constants';
import {
  REQUIRED,
  MIN_2_CHARS,
  MAX_255_CHARS,
  INVALID_DATE_MESSAGE,
  EMPLOYMENT_END_DATE_MESSAGE,
} from '@/lib/validations';

const {
  EMPLOYER_NAME,
  EMPLOYER_START_DATE,
  EMPLOYER_END_DATE,
} = onboardingConstants;

export const validationSchema = yup.object().shape({
  [EMPLOYER_NAME]: yup
    .string()
    .checkWhiteSpacesOnly(REQUIRED)
    .when(['$isAdmin', '$isWizard'], (isAdmin, isWizard, schema) => {
      return !isWizard && isAdmin ? schema : schema.required(REQUIRED);
    })
    .matches(/.{2,}/, {
      excludeEmptyString: true,
      message: MIN_2_CHARS,
    })
    .max(255, MAX_255_CHARS)
    .nullable(),
  [EMPLOYER_START_DATE]: yup
    .date()
    .when(['$isAdmin', '$isWizard'], (isAdmin, isWizard, schema) => {
      return !isWizard && isAdmin
        ? schema.nullable().transform((value) => (value instanceof Date && !isNaN(value) ? value : null))
        : schema.required(REQUIRED);
    })
    .nullable()
    .typeError(INVALID_DATE_MESSAGE),
  [EMPLOYER_END_DATE]: yup
    .date()
    .when(['$isAdmin', '$isWizard'], (isAdmin, isWizard, schema) => {
      return !isWizard && isAdmin
        ? schema.nullable().transform((value) => (value instanceof Date && !isNaN(value) ? value : null))
        : schema.required(REQUIRED);
    })
    .nullable()
    .min(
      yup.ref(EMPLOYER_START_DATE),
      EMPLOYMENT_END_DATE_MESSAGE,
    )
    .typeError(INVALID_DATE_MESSAGE),
});
